import store from '@/store';
import { MetaRoles, Roles } from '@/core/constants/roleConstants';

import DailyHome from '../views/daily/director/Home.vue';
import ChannelSelectionView from '@/views/auth/ChannelSelectionView.vue';
import Policies from '@/core/policies';
import { authenticated } from './guards/authGuards';
import { authorized } from './guards/authorizationGuards';
import { go } from './guards/helpers';

export const hasAnyRole = (storeroles, roles) => {
  return storeroles.some((role) => roles.includes(role.name));
};

export default [
  {
    path: '/daily',
    name: 'DailyDirector',
    component: DailyHome,
    meta: { role: MetaRoles[Roles.DIRECTOR] },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (!store.getters['auth/authenticatedDirector']) {
        return next({
          name: 'DirectorChannelSelection',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          Roles.DIRECTOR,
          Roles.DIRECTOR_NON_COMMERCIAL,
          Roles.SUPER_USER,
          Roles.POST_SALE,
          Roles.MARKETING,
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/rg-channel-selection',
    name: 'RGChannelSelection',
    component: ChannelSelectionView,
    meta: { role: MetaRoles[Roles.REGIONAL_MANAGER] },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (!hasAnyRole(store.getters['auth/roles'], [Roles.REGIONAL_MANAGER])) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/daily-regional-manager',
    name: 'DailyRegionalManager',
    component: DailyHome,
    meta: { role: MetaRoles[Roles.REGIONAL_MANAGER] },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          Roles.DIRECTOR,
          Roles.SUB_DIRECTOR,
          Roles.REGIONAL_MANAGER,
          Roles.SUB_DIRECTOR_NON_COMMERCIAL_WHOLESALER,
          Roles.SUB_DIRECTOR_NON_COMMERCIAL_RETAIL,
          Roles.DIRECTOR_NON_COMMERCIAL,
          Roles.SUPER_USER,
          Roles.POST_SALE,
          Roles.MARKETING,
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/daily-sub-director',
    name: 'DailySubDirector',
    component: DailyHome,
    meta: { role: MetaRoles[Roles.SUB_DIRECTOR] },
    props: true,
    beforeEnter: (to, from, next) =>
      next(
        authenticated() ||
          authorized(Policies.DailySubdirectorPolicy.canView()) ||
          go()
      ),
  },
];
